import api from "./api";

// Get audit logs for a specific entity
export const getAuditLogsByEntity = (entityType, entityId) => {
  return api.get(`/audit/entity/${entityType}/${entityId}`);
};

// Get audit logs by user
export const getAuditLogsByUser = (userId, page = 0, size = 20) => {
  return api.get(`/audit/user/${userId}`, {
    params: { page, size }
  });
};

// Get recent audit logs (paginated)
export const getRecentAuditLogs = (page = 0, size = 20) => {
  return api.get(`/audit/recent`, {
    params: { page, size }
  });
};

// Get employee audit logs (for admin's employees)
export const getEmployeeAuditLogs = (filter, page = 0, size = 20) => {
  return api.get(`/audit/employees`, {
    params: { filter, page, size }
  });
};

// Search audit logs with RSQL filter
export const searchAuditLogs = (filter, page = 0, size = 20) => {
  return api.get(`/audit/search`, {
    params: { filter, page, size }
  });
};

const auditService = {
  getAuditLogsByEntity,
  getAuditLogsByUser,
  getRecentAuditLogs,
  getEmployeeAuditLogs,
  searchAuditLogs
};

export default auditService;
